import { render, staticRenderFns } from "./choose_column.vue?vue&type=template&id=529392dc&scoped=true&"
import script from "./choose_column.vue?vue&type=script&lang=js&"
export * from "./choose_column.vue?vue&type=script&lang=js&"
import style0 from "./choose_column.vue?vue&type=style&index=0&id=529392dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529392dc",
  null
  
)

export default component.exports